import { useAuth } from "react-oidc-context";
import { jwtDecode } from "jwt-decode";

export function useJwt() {
    const { user } = useAuth();

    if (!user || !user.access_token) {
        return null;
    }

    try {
        const decodedJwt = jwtDecode(user.access_token, { header: false });
        return decodedJwt;
    } catch (error) {
        console.error("JWT decode failed:", error);
        return null;
    }
}
